import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {labels} from '../../../util/utils';
import {IconoirXmark} from '@ey-xd/motif-icon';
import {IconButton} from '@ey/canvascoreservices';
import StyledDrawer from './StyledDrawer';
import StyledDrawerWrapper from './StyledDrawerWrapper';
import StyledCloseButton from './StyledCloseButton';
import ErrorSummary from '../ErrorSummary/ErrorSummary';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import styled from 'styled-components';

export default function Drawer({children, open, setOpen, headerTitle, showCloseButtonTooltip}) {
	const props = {
		className: classNames({open})
	};

	if (!open) return null;

	const renderCloseButton = () => {
		const props = {
			onClick: () => setOpen && setOpen(false),
			svg: IconoirXmark,
			title: labels.close,
			type: 'button',
			variant: 'ghost'
		};
		if (showCloseButtonTooltip) {
			props.variant = 'default';
			props.showLabelTitle = true;
		}

		return (
			<StyledDrawerHeaderWrapper className="drawerHeaderWrapper">
				{headerTitle && (
					<section className="headerTitleWrapper">
						<EllipsesControl content={headerTitle} tooltip={headerTitle} />
					</section>
				)}
				<StyledCloseButton className="StyledCloseButton">
					<IconButton {...props} />
				</StyledCloseButton>
			</StyledDrawerHeaderWrapper>
		);
	};

	return (
		<StyledDrawerWrapper className="StyledDrawerWrapper">
			<StyledDrawer className="StyledDrawer" {...props}>
				<ErrorSummary />
				{renderCloseButton()}
				{children}
			</StyledDrawer>
		</StyledDrawerWrapper>
	);
}

Drawer.propTypes = {
	open: PropTypes.bool,
	setOpen: PropTypes.func
};

Drawer.defaultProps = {
	open: false,
	setOpen: null
};

const StyledDrawerHeaderWrapper = styled.section`
	display: flex;
	align-items: center;
	--gap: var(--px-30);
	padding: var(--gap) var(--gap) 0 var(--gap);
	width: 100%;
	background: linear-gradient(119deg, var(--neutrals-bg-gradient1) 19.79%, var(--neutrals-bg-gradient2) 99.54%);
	z-index: 2;
	.headerTitleWrapper {
		.ellipses {
			div {
				font-size: var(--px-32);
				font-weight: 400;
				line-height: var(--px-42);
				color: var(--neutrals-900);
			}
		}
	}
	.StyledCloseButton {
		flex: 1;
		.motif-button {
			margin-left: auto;
		}
	}
`;
